import { APP_BRANDING_STORAGE_KEY, appBrandSelectionSchema } from "./types";

const CHANGE_EVENT = "needl-app-branding-change";

export const readAppBrandSelection = (): string | undefined => {
  let raw: string | null = null;
  try {
    raw = window.localStorage.getItem(APP_BRANDING_STORAGE_KEY);
  } catch {
    return undefined;
  }
  if (!raw) return undefined;

  const parsed = appBrandSelectionSchema.safeParse(safeJsonParse(raw));
  if (parsed.success) return parsed.data.activeId;

  clearAppBrandSelection();
  return undefined;
};

export class AppBrandStorageError extends Error {}

/** Raises rather than degrades: a write that does not land is a brand that
    silently never applies. */
export const writeAppBrandSelection = (activeId: string): void => {
  try {
    window.localStorage.setItem(
      APP_BRANDING_STORAGE_KEY,
      JSON.stringify({ activeId }),
    );
  } catch {
    throw new AppBrandStorageError("This browser is not allowing site storage");
  }
  notifyChange();
};

export const clearAppBrandSelection = (): void => {
  try {
    window.localStorage.removeItem(APP_BRANDING_STORAGE_KEY);
  } catch {
    return;
  }
  notifyChange();
};

export const subscribeToAppBrandSelection = (
  listener: () => void,
): (() => void) => {
  const onStorage = (event: StorageEvent) => {
    if (event.key === null || event.key === APP_BRANDING_STORAGE_KEY) {
      listener();
    }
  };

  window.addEventListener(CHANGE_EVENT, listener);
  window.addEventListener("storage", onStorage);

  return () => {
    window.removeEventListener(CHANGE_EVENT, listener);
    window.removeEventListener("storage", onStorage);
  };
};

const notifyChange = () => {
  window.dispatchEvent(new Event(CHANGE_EVENT));
};

const safeJsonParse = (raw: string): unknown => {
  try {
    return JSON.parse(raw);
  } catch {
    return undefined;
  }
};
